//
//
//
//
//
//
//
//

import Appbar from '@/components/core/Appbar.vue';
import Footer from '@/components/core/Footer.vue';

export default {
	components: {
		Appbar,
		Footer,
	},
};
